import { createAction } from 'typesafe-actions';

import { type PendingCertification, type PendingRequest } from '../../models';

export const certificationsRequested = createAction(
  'recentAssignments/certificationsRequested'
)<void>();

export const certificationsReceived = createAction(
  'recentAssignments/certificationsReceived'
)<PendingCertification[]>();

export const certificationsNotReceived = createAction(
  'recentAssignments/certificationsNotReceived'
)<void>();

export const requestsRequested = createAction(
  'recentAssignments/requestsRequested'
)<void>();

export const requestsReceived = createAction(
  'recentAssignments/requestsReceived'
)<PendingRequest[]>();

export const requestsNotReceived = createAction(
  'recentAssignments/requestsNotReceived'
)<void>();
